import { styled } from '@mui/material'

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: inherit;
  justify-content: space-between;
`

export const TextContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  text-align: center;
  flex-grow: 1;
  justify-content: center;
`

export const NumpadContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSmallScreen',
})<{ isSmallScreen?: boolean }>`
  height: ${({ theme, isSmallScreen }) => theme.spacing(isSmallScreen ? 50.75 : 56.5)};
  background-color: ${({ theme }) => theme.palette.background.base};
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`
